import Layout from "@/components/Layout"
import Wishlist from "@/containers/Wishlist"
import { checkForWrongDomain } from "src/utils/checkForWrongDomain";
import { getMetaDescription } from "src/utils/getMetaDescription";
// import { getRequiredCtxProps } from "src/utils/getRequiredCtxProps";
// import { getSSRStoreData } from "src/utils/ssrPageData";
import { useSetSSRStore, useSSRSelector } from "src/redux";
import { getSSRStoreData } from "src/utils/ssrPageData";

const WishlistPage = (props) => {
    const storeInfo = useSSRSelector((state) => state.storeReducer.store);
    useSetSSRStore(props.ssrStore);
    return (
        <Layout
          store={storeInfo}
          title={`${storeInfo?.store_info?.name}${
            storeInfo?.address?.visibility === 1 && storeInfo?.address?.city
              ? `, ${storeInfo.address?.city}`
              : ''
          } - Order Online`}
          Icon={storeInfo?.store_info?.logo_image}
          metaDescription={storeInfo && getMetaDescription(storeInfo)}
          OGImage={storeInfo?.store_info?.logo_image}
        >
          <Wishlist props={props}/>
        </Layout>
    )
}

export async function getServerSideProps(ctx) {
    if (checkForWrongDomain(ctx)) return {};
  
    let propData = {
      wishlistData: [],
    };

    const propType = await getSSRStoreData(ctx, {
      additionalDataToFetch: ['collections', 'categories', 'advancedSeo'],
    });
  
    propData = { ...propData, ...propType };
  
    return { props: { ...propData } };
}

export default WishlistPage;